export const FailureIcon = () => (
  <svg width='44' height='43' viewBox='0 0 44 43' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <ellipse cx='21.9999' cy='21.8648' rx='21.6308' ry='20.9753' fill='url(#paint0_linear_12280_26302)' />
    <path d='M22 10.6361L22 24.8289' stroke='white' stroke-width='3.22266' />
    <path d='M22 28.8485L22 32.2628' stroke='white' stroke-width='3.22266' />
    <defs>
      <linearGradient
        id='paint0_linear_12280_26302'
        x1='3.3354'
        y1='5.33481'
        x2='44.8182'
        y2='55.0116'
        gradientUnits='userSpaceOnUse'>
        <stop stop-color='#FF6565' />
        <stop offset='1' stop-color='#D00F0F' />
      </linearGradient>
    </defs>
  </svg>
)
